module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('img', {
    staticClass: "header-img",
    attrs: {
      "src": require("../../../../assets/images/bg-top@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.row.club_list.length == 0) ? _c('div', {
    staticClass: "no_club"
  }, [_c('div', {
    staticStyle: {
      "height": "3.56rem"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px",
      "color": "#999",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.row.user.name) + "(" + _vm._s(_vm.row.user.phone) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "create_btn",
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("切换账号")])]) : _vm._e(), _vm._v(" "), (_vm.row.club_list.length > 0) ? _c('div', {
    staticClass: "club"
  }, [_c('h1', [_vm._v(_vm._s(_vm.row.club.name))]), _vm._v(" "), _c('div', {
    staticClass: "level"
  }, [_c('h1', [_vm._v("俱乐部等级")]), _vm._v(" "), (_vm.row.club.bgrade == '一星') ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-yixiji@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.club.bgrade == '二星') ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-yixiji@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.club.bgrade == '二星') ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-yixiji@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.club.bgrade == '三星') ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-yixiji@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.club.bgrade == '三星') ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-yixiji@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.club.bgrade == '三星') ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-yixiji@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.club.bgrade == '四星') ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-yixiji@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.club.bgrade == '四星') ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-yixiji@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.club.bgrade == '四星') ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-yixiji@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.club.bgrade == '四星') ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-yixiji@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.club.bgrade == '五星') ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-yixiji@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.club.bgrade == '五星') ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-yixiji@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.club.bgrade == '五星') ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-yixiji@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.club.bgrade == '五星') ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-yixiji@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.club.bgrade == '五星') ? _c('img', {
    attrs: {
      "src": require("../../../../assets/images/icon-yixiji@2x.png"),
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "color": "#999"
    },
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v(_vm._s(_vm.row.user.name) + "(" + _vm._s(_vm.row.user.phone) + ") [切换账号]")]), _vm._v(" "), _c('div', {
    staticClass: "br",
    staticStyle: {
      "margin-top": "0.4rem"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "flex-wrap": "wrap"
    }
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.sheetActiveShow = true
      }
    }
  }, [_vm._v("切换俱乐部")]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.goClubGrade()
      }
    }
  }, [_vm._v("俱乐部升级")]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goDakejian()
      }
    }
  }, [_vm._v("申报大课间")]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goSihao()
      }
    }
  }, [_vm._v("四好运动员")])])]) : _vm._e()]), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "description": "将以新的俱乐部主体参赛报名",
      "actions": _vm.row.club_list,
      "cancel-text": "取消",
      "close-on-click-action": ""
    },
    on: {
      "cancel": _vm.onSheetCancel,
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.sheetActiveShow),
      callback: function($$v) {
        _vm.sheetActiveShow = $$v
      },
      expression: "sheetActiveShow"
    }
  }), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "description": "将以新的单位为主体参赛报名",
      "actions": _vm.row.danwei_list,
      "cancel-text": "取消",
      "close-on-click-action": ""
    },
    on: {
      "cancel": _vm.onSheetCancel,
      "select": _vm.onDanweiSelect
    },
    model: {
      value: (_vm.sheetDanweiActiveShow),
      callback: function($$v) {
        _vm.sheetDanweiActiveShow = $$v
      },
      expression: "sheetDanweiActiveShow"
    }
  }), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-755e3453","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/mine/club/ClubDakejianSihao.vue
// module id = 2486
// module chunks = 0